import styles from "./NavTopBarHeaderEnd.module.scss"
import { NavTopBarHeaderEndProps } from "./NavTopBarHeaderEnd.types"

export default function NavTopBarHeaderEnd(props: NavTopBarHeaderEndProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
